import { getAppCtx } from "../hooks/use-app-ctx" // eslint-disable-line @typescript-eslint/no-unused-vars

/**
 * @deprecated Use {@link getAppCtx} if possible instead
 */
export function getAbsoluteRepoUrl(repoUrl: string, localRepoUrl?: string) {
  const { origin } = window.location
  const url = origin.includes('localhost') && localRepoUrl ? localRepoUrl : repoUrl

  if (url.startsWith('http://') || url.startsWith('https://')) return url
  if (url.startsWith('/')) return origin + url
  return `${origin}/${url}`
}
